import { useMemo } from "react"

import { getVariantKeyAttributes } from "entities/products/lib/getProductType"

export function useVariantKey(variantKey: null): {
  productType: null
  attributes: []
}
export function useVariantKey(variantKey: string): {
  productType: string
  attributes: string[]
}
export function useVariantKey(variantKey: string | null): {
  productType: string | null
  attributes: string[]
}
export function useVariantKey(variantKey: string | null) {
  const attributes = useMemo(
    () => getVariantKeyAttributes(variantKey),
    [variantKey]
  )

  return {
    productType: attributes?.[0]?.toUpperCase() || null,
    attributes: attributes || []
  }
}
